import React from 'react'
import SALink from 'components/SALink'
import { Thumbline, TitleBanner, CollectionImage } from '../../styles'

const ArtworkImage = (
  props: Record<string, any>
): React.ReactElement<React.ComponentProps<any>, any> => {
  const { imageUrl, collectionTitle, collectionCount, collectionUrl, thumbs, index } = props
  const imageBase = imageUrl.replace('-25.jpg', '')
  const placeHolder = imageUrl.search('-square-93.jpg') > -1
  // If image is not a placeholder, show the first eight items with no lazyloading
  // to prevent lazysizes from firing on images that might be in the viewport
  const topLine = index < 9 && !placeHolder
  // The rest of the array gets lazyloading
  const mainLine = index >= 9 && !placeHolder
  return (
    <SALink href={collectionUrl} title={`Go to Collection ${collectionTitle}`} itemProp='url'>
      <CollectionImage>
        {topLine && (
          <img
            data-type='mainImage'
            width='290'
            height='290'
            src={`${imageBase}-25.jpg`}
            alt={`Collection ${collectionTitle}`}
            itemProp='image'
          />
        )}
        {mainLine && (
          <img
            data-type='mainImage'
            width='290'
            height='290'
            className='lazyload'
            loading='lazy'
            src={`${imageBase}-25.jpg`}
            alt={`Collection ${collectionTitle}`}
            itemProp='image'
          />
        )}
        {placeHolder && (
          <img
            data-type='mainImage'
            data-src={`${imageUrl}`}
            alt={`Collection ${collectionTitle}`}
            itemProp='image'
            className='lazyload'
            width='290'
            height='290'
          />
        )}

        <TitleBanner>
          <span key={`copy-1-${index}`} itemProp='name'>
            {collectionTitle}{' '}
          </span>
          <span key={`copy-2-${index}`}>({collectionCount})</span>
        </TitleBanner>
      </CollectionImage>

      <Thumbline>
        {thumbs.map((thumb, key) => {
          return (
            <img
              data-type='thumb-image'
              key={`thumb-${key}-${index}`}
              src={thumb}
              alt={`Collection ${collectionTitle}`}
              itemProp='image'
              width='93'
              height='93'
            />
          )
        })}
      </Thumbline>
    </SALink>
  )
}

export default ArtworkImage